module.exports = __webpack_public_path__ + "static/media/graphql.762edb84.png";